// Dependencies
import React from 'react';
import radium from 'radium';
import Checkbox from "../../../components/checkbox/Checkbox.tsx";
import { ThemeContext } from "../../../components/theme/Theme.jsx";
import LeoPopup from "../../../components/popup/LeoPopup";

function TermsAndConditions(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		checkbox: {
			margin: '0 0 0.7em 0',
			justifyContent: 'flex-start',
		},
		labelHighlight: {
			color: context.themeManager.value('checkout-agb-link', 'color', 'fg-color-link-default'),
			marginLeft: '.4em',
			cursor: 'pointer',
		},
		hintContainer: {
			display: 'flex',
			justifyContent: 'center',
			paddingLeft: '1.7em',
			paddingRight: '0.5em',
			margin: '0 0 2em 0',
		},
	}
	const description = context.themeManager.getThemeTextOrHardcodedDefault('termsAndConditionDescription')
	const [showPopupAgb, setShowPopupAgb] = React.useState(false)

	function toggleAgbPopup(e) {
		setShowPopupAgb(!showPopupAgb)
		e.preventDefault()
	}

	return (
		<div>
			<Checkbox
				ariaDescription={description}
				name="termsAndConditions"
				value="AGB_ACCEPT"
				onChange={(event) => props.onTermsAndConditionsChange(event.target.checked)}
				checked={props.termsAndConditions}
				label={
					<span>
					Ich akzeptiere die
					<button
						className={"leo__button-sample"}
						aria-description={"Öffnet die Allgemeinen Geschäftsbedingungen in Popup-Fenster."}
						style={style.labelHighlight}
						onClick={toggleAgbPopup}
					>
						AGBs
					</button>.
				</span>
				}
				style={style.checkbox}
			/>
			{showPopupAgb &&
				<LeoPopup
					headline={context.themeManager.getThemeText('agbPopupHeadline')}
					onClose={toggleAgbPopup}
				>
					{context.themeManager.getThemeText('agbPopupText')}
				</LeoPopup>
			}
		</div>
	);
}

export default radium(TermsAndConditions)
